'use strict';

// list of mime types
module.exports = {
    'doc': 'application/msword',
    'docx': 'application/msword',
    'pdf': 'application/pdf',
    'rss': 'application/rss+xml',
    'xls': 'application/vnd.ms-excel',
    'xlsx': 'application/vnd.ms-excel',
    'pps': 'application/vnd.ms-powerpoint',
    'ppt': 'application/vnd.ms-powerpoint',
    'pptx': 'application/vnd.ms-powerpoint',
    'odp': 'application/vnd.oasis.opendocument.presentation',
    'ods': 'application/vnd.oasis.opendocument.spreadsheet',
    'odt': 'application/vnd.oasis.opendocument.text',
    'sxc': 'application/vnd.sun.xml.calc',
    'sxw': 'application/vnd.sun.xml.writer',
    'au': 'audio/basic',
    'snd': 'audio/basic',
    'flac': 'audio/flac',
    'mid': 'audio/mid',
    'rmi': 'audio/mid',
    'm4a': 'audio/mp4',
    'mp3': 'audio/mpeg',
    'oga': 'audio/ogg',
    'ogg': 'audio/ogg',
    'aif': 'audio/x-aiff',
    'aifc': 'audio/x-aiff',
    'aiff': 'audio/x-aiff',
    'wav': 'audio/x-wav',
    'gif': 'image/gif',
    'jpeg': 'image/jpeg',
    'jpg': 'image/jpeg',
    'jpe': 'image/jpeg',
    'png': 'image/png',
    'tiff': 'image/tiff',
    'tif': 'image/tiff',
    'wbmp': 'image/vnd.wap.wbmp',
    'bmp': 'image/x-ms-bmp',
    'ics': 'text/calendar',
    'csv': 'text/comma-separated-values',
    'css': 'text/css',
    'htm': 'text/html',
    'html': 'text/html',
    'text': 'text/plain',
    'txt': 'text/plain',
    'asc': 'text/plain',
    'diff': 'text/plain',
    'pot': 'text/plain',
    'vcf': 'text/x-vcard',
    'mp4': 'video/mp4',
    'mpeg': 'video/mpeg',
    'mpg': 'video/mpeg',
    'mpe': 'video/mpeg',
    'ogv': 'video/ogg',
    'qt': 'video/quicktime',
    'mov': 'video/quicktime',
    'avi': 'video/x-msvideo',
    'zip': 'application/zip',
    'rar': 'application/x-rar-compressed'
};